<div class="dialog-container">
    <h3>{{ data.title }}</h3>
    <p>{{ data.message }}</p>

    <div class="button-group">
        <button mat-stroked-button class="cancel-btn" (click)="onCancel()">
            {{ data.cancelText || 'Cancel' }}
        </button>

        <button mat-flat-button color="warn" class="delete-btn" (click)="onConfirm()">
            {{ data.confirmText || 'Delete' }}
        </button>
    </div>
</div>